import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { FaCheckCircle, FaClipboardList, FaHome } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const OrderSuccess = () => {
  const { t } = useTranslation();
  const { orderId } = useParams();
  const location = useLocation();

  // Attempt to get transactionId and message from the state passed by Checkout.jsx
  const { transactionId, message, userOrderCount } = location.state || {};

  return (
    <div className="canvas-background mx-auto py-12 px-4 sm:px-6 lg:px-[11rem] min-h-screen flex justify-center items-center">
      <div className="max-w-4xl w-full bg-white rounded-xl p-10 shadow-2xl border-t-8 border-green-500 text-center">
        <FaCheckCircle className="text-green-500 mx-auto w-20 h-20 mb-6 animate-pulse" />

        <h1 className="text-4xl font-extrabold text-gray-900 mb-4">
          {t("orderSuccessTitle", "Order Placed Successfully!")} 🎉
        </h1>

        <p className="text-lg text-gray-700 mb-2">
          {t("thankYou", "Thank you for your purchase.")}
        </p>

        <p className="text-2xl font-bold text-[#83375B] mb-6 border-b pb-4">
          {t("orderNumber", "Order Number")}: #
          {userOrderCount ? userOrderCount + 1 : orderId}
        </p>

        {message && (
          <p className="text-md text-gray-600 mb-2">
            {t("serverMessage", "Server Message")}: {message}
          </p>
        )}
        {transactionId && (
          <p className="text-md text-gray-600 mb-6">
            {t("transactionId", "Transaction ID")}: {transactionId}
          </p>
        )}

        <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 mt-8">
          <Link
            to="/profile?tab=orders"
            className="flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-[#AA7F96] hover:bg-[#916A80] transition-colors shadow-md"
          >
            <FaClipboardList className="mr-3" />
            {t("viewOrder", "View My Orders")}
          </Link>
          <Link
            to="/"
            className="flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition-colors shadow-md"
          >
            <FaHome className="mr-3" />
            {t("continueShopping", "Continue Shopping")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
